import { render, staticRenderFns } from "./EditGame.vue?vue&type=template&id=70cef276"
import script from "./EditGame.vue?vue&type=script&lang=js"
export * from "./EditGame.vue?vue&type=script&lang=js"
import style0 from "./EditGame.vue?vue&type=style&index=0&id=70cef276&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports